export default __webpack_public_path__ + "static/media/primary-white.6fde7617.svg";